"use strict";

require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.freeze.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutputCardContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constellation = require("@zillow/constellation");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var OutputCardContainer = exports.OutputCardContainer = (0, _styledComponents["default"])(_constellation.Spacer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 120px;\n  flex: 1;\n  margin-right: 24px;\n  border-radius: 5px;\n  background-color: ", ";\n\n  :last-of-type {\n    margin-right: 0;\n  }\n"])), (0, _constellation.token)('colors.coolGray100'));